import { DateTimeUnit } from "luxon";
import { IllegalArgumentError, UnsupportedError } from "shared-ts-utils-core";

export const flueBurnMetricAggregateTimeUnits = {
  ever: "@ever",
  sinceSweep: "@sinceSweep",
  atSweep: "@atSweep",
  atSensorOperational: "@atSensorOperational",
  year: "year",
  quarter: "quarter",
  month: "month",
  week: "week",
  day: "day",
};
export type FlueBurnMetricAggregateTimeUnit =
  (typeof flueBurnMetricAggregateTimeUnits)[keyof typeof flueBurnMetricAggregateTimeUnits];

export class FlueBurnMetricAggregateTimeUnitUtils {
  static toDateTimeUnit(
    timeUnit: FlueBurnMetricAggregateTimeUnit
  ): DateTimeUnit {
    if (timeUnit === flueBurnMetricAggregateTimeUnits.year) {
      return "year";
    } else if (timeUnit === flueBurnMetricAggregateTimeUnits.quarter) {
      return "quarter";
    } else if (timeUnit === flueBurnMetricAggregateTimeUnits.month) {
      return "month";
    } else if (timeUnit === flueBurnMetricAggregateTimeUnits.week) {
      return "week";
    } else if (timeUnit === flueBurnMetricAggregateTimeUnits.day) {
      return "day";
    } else if (timeUnit === flueBurnMetricAggregateTimeUnits.ever) {
      return "day";
    } else if (timeUnit === flueBurnMetricAggregateTimeUnits.sinceSweep) {
      return "day";
    } else if (
      timeUnit === flueBurnMetricAggregateTimeUnits.atSensorOperational
    ) {
      return "day";
    } else if (timeUnit === flueBurnMetricAggregateTimeUnits.atSweep) {
      return "day";
    } else {
      throw new UnsupportedError("timeUnit: " + timeUnit);
    }
  }

  static parse(str: string): FlueBurnMetricAggregateTimeUnit {
    // TODO: Remove this after release of 2025.2
    if (str.toLowerCase().endsWith("ever")) {
      str = flueBurnMetricAggregateTimeUnits.ever;
    } else if (str.toLowerCase().endsWith("sincesweep")) {
      str = flueBurnMetricAggregateTimeUnits.sinceSweep;
    } else if (str.toLowerCase().endsWith("year")) {
      str = flueBurnMetricAggregateTimeUnits.year;
    } else if (str.toLowerCase().endsWith("month")) {
      str = flueBurnMetricAggregateTimeUnits.month;
    } else if (str.toLowerCase().endsWith("week")) {
      str = flueBurnMetricAggregateTimeUnits.week;
    } else if (str.toLowerCase().endsWith("day")) {
      str = flueBurnMetricAggregateTimeUnits.day;
    }

    if (str === flueBurnMetricAggregateTimeUnits.ever) {
      return flueBurnMetricAggregateTimeUnits.ever;
    } else if (str === flueBurnMetricAggregateTimeUnits.atSensorOperational) {
      return flueBurnMetricAggregateTimeUnits.atSensorOperational;
    } else if (str === flueBurnMetricAggregateTimeUnits.sinceSweep) {
      return flueBurnMetricAggregateTimeUnits.sinceSweep;
    } else if (str === flueBurnMetricAggregateTimeUnits.year) {
      return flueBurnMetricAggregateTimeUnits.year;
    } else if (str === flueBurnMetricAggregateTimeUnits.quarter) {
      return flueBurnMetricAggregateTimeUnits.quarter;
    } else if (str === flueBurnMetricAggregateTimeUnits.month) {
      return flueBurnMetricAggregateTimeUnits.month;
    } else if (str === flueBurnMetricAggregateTimeUnits.week) {
      return flueBurnMetricAggregateTimeUnits.week;
    } else if (str === flueBurnMetricAggregateTimeUnits.day) {
      return flueBurnMetricAggregateTimeUnits.day;
    } else {
      throw new IllegalArgumentError(
        "Given string is not a valid FlueBurnMetricAggregateTimeUnit: " + str
      );
    }
  }
}
